import React, { useRef, useState, useEffect} from "react"

// From: https://usehooks.com/useWindowSize/
// Hook
export const useWindowSize = function(actualWindow = window) {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: actualWindow.innerWidth,
        height: actualWindow.innerHeight,
      });
    }
    
    // Add event listener
    actualWindow.addEventListener("resize", handleResize);
    
    // Call handler right away so state gets updated with initial window size
    handleResize();
    
    // Remove event listener on cleanup
    return () => actualWindow.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return windowSize;
}

export const useMousePosition = (actualWindow = window) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const setFromEvent = e => setPosition({ x: e.clientX, y: e.clientY });
    actualWindow.addEventListener("mousemove", setFromEvent);

    return () => {
      actualWindow.removeEventListener("mousemove", setFromEvent);
    };
  }, []);

  return position;
};